import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  deleteResidentDocumentFailure,
  deleteResidentDocumentSuccess,
  getResidentDocuments,
  getResidentDocumentsFailure,
  getResidentDocumentsSuccess,
  saveResidentDocumentFailure,
  saveResidentDocumentSuccess,
} from "./actions";
import {
  DELETE_RESIDENT_DOCUMENT,
  GET_RESIDENT_DOCUMENTS,
  SAVE_RESIDENT_DOCUMENT,
} from "./constants";

export function* getResidentDocumentsSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-documents?${query}`,
      payload,
    );
    yield put(getResidentDocumentsSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getResidentDocumentsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching resident documents!"));
  }
}

export function* saveResidentDocumentSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-documents/save`,
      payload,
    );
    if (data) {
      yield put(successAlert("Document saved successfully!"));
      yield put(saveResidentDocumentSuccess());
      const residentId = payload.get?.("resident_id");
      if (residentId) {
        const templateId = payload.get?.("template_id");
        const versionId = payload.get?.("version_id");
        const listParams = {
          resident_id: residentId,
          page: 1,
          limit: 10,
          ...(templateId && { template_id: templateId }),
          ...(versionId && { version_id: versionId }),
        };
        yield put(getResidentDocuments(listParams));
      }
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(saveResidentDocumentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteResidentDocumentSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).delete,
      `/api/resident-document/${payload}`,
    );
    if (data) {
      yield put(successAlert("Document deleted successfully!"));
      yield put(deleteResidentDocumentSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteResidentDocumentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getResidentDocumentsFlow() {
  yield takeEvery(GET_RESIDENT_DOCUMENTS, getResidentDocumentsSaga);
}
export function* saveResidentDocumentFlow() {
  yield takeEvery(SAVE_RESIDENT_DOCUMENT, saveResidentDocumentSaga);
}
export function* deleteResidentDocumentFlow() {
  yield takeEvery(DELETE_RESIDENT_DOCUMENT, deleteResidentDocumentSaga);
}

export default function* ResidentDocumentsSaga() {
  yield all([
    getResidentDocumentsFlow(),
    saveResidentDocumentFlow(),
    deleteResidentDocumentFlow(),
  ]);
}
